import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTE_NAMES } from "./Routes";
import Layout from "./Pages/Layout";
import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
// import Team from "./Pages/Team";
import Projects from "./Pages/Projects";
import Blogs from "./Pages/Blogs";

import Press from "./Pages/Press";
import PressPage1 from "./Pages/PressPage1";
import PressPage2 from "./Pages/PressPage2";
import PressPage3 from "./Pages/PressPage3";
import PressPage4 from "./Pages/PressPage4";
import PressPage5 from "./Pages/PressPage5";
import PressPage6 from "./Pages/PressPage6";
import PressPage7 from "./Pages/PressPage7";

import ContactUs from "./Pages/ContactUs";
import InvestInProject from "./Pages/InvestPage";

import DevelopmentDesignServices from "./Pages/DevelopmentDesignServices";
// import RealEstateDevelopment from "./Pages/RealEstateDevelopmentService";
// import PreDevelopmentPlanningServices from "./Pages/PreDevelopmentPlanningService";
// import DesignBuildConstructionService from "./Pages/DesignBuildConstructionService";
// import SmartSustainableService from "./Pages/SmartSustainableService";

import CapitalInvestmentServices from "./Pages/CapitalInvestmentServices";
// import CapitalVenturesServices from "./Pages/CapitalVenturesService";
// import LendingSolutionsServices from "./Pages/LendingSolutionsService";
import EBService from "./Pages/EBService";

import ConstructionServices from "./Pages/ConstructionServices";
import BrokerageServices from "./Pages/BrokerageService";
import MortgageServices from "./Pages/MortgageServices";
import LendingServices from "./Pages/LendingServices";

// import ElitePropertyManagmentServices from "./Pages/ElitePropertyManagmentService";

//project pages
import HollywoodProject from "./Pages/ProjectsPagesGrouped/HollywoodProject";
import StarlifePlazaProject from "./Pages/ProjectsPagesGrouped/StarlifePlazaProject";
import RiverlandMansionProject from "./Pages/ProjectsPagesGrouped/RiverlandMansion";
import RiverlandEstatesProject from "./Pages/ProjectsPagesGrouped/RiverlandEstates";
import CoralRidgeVillasProject from "./Pages/ProjectsPagesGrouped/CoralRidgeVillas";
import CoralRidgeResidencesProject from "./Pages/ProjectsPagesGrouped/CoralRidgeResidences";
import DaniaBeachVillasProject from "./Pages/ProjectsPagesGrouped/DaniaBeachVillas";
import PressPage8 from "./Pages/PressPage8";
import PressPage9 from "./Pages/PressPage9";
import PressPage10 from "./Pages/PressPage10";
import PressPage11 from "./Pages/PressPage11";
import PressPage12 from "./Pages/PressPage12";

function App() {
  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path={ROUTE_NAMES.HOME} element={<Home />} />
            <Route path={ROUTE_NAMES.COMPANY} element={<AboutUs />} />
            {/* <Route path={ROUTE_NAMES.TEAM} element={<Team />} /> */}
            <Route path={ROUTE_NAMES.PROJECTS} element={<Projects />} />
            <Route path={ROUTE_NAMES.BLOG} element={<Blogs />} />
            <Route path={ROUTE_NAMES.PRESS} element={<Press />} />
            <Route path={ROUTE_NAMES.PRESS1} element={<PressPage1 />} />
            <Route path={ROUTE_NAMES.PRESS2} element={<PressPage2 />} />
            <Route path={ROUTE_NAMES.PRESS3} element={<PressPage3 />} />
            <Route path={ROUTE_NAMES.PRESS4} element={<PressPage4 />} />
            <Route path={ROUTE_NAMES.PRESS5} element={<PressPage5 />} />
            <Route path={ROUTE_NAMES.PRESS6} element={<PressPage6 />} />
            <Route path={ROUTE_NAMES.PRESS7} element={<PressPage7 />} />
            <Route path={ROUTE_NAMES.PRESS8} element={<PressPage8 />} />
            <Route path={ROUTE_NAMES.PRESS9} element={<PressPage9 />} />
            <Route path={ROUTE_NAMES.PRESS10} element={<PressPage10 />} />
            <Route path={ROUTE_NAMES.PRESS11} element={<PressPage11 />} />
            <Route path={ROUTE_NAMES.PRESS12} element={<PressPage12 />} />
            <Route path={ROUTE_NAMES.CONTACT} element={<ContactUs />} />
            <Route path={ROUTE_NAMES.INVEST} element={<InvestInProject />} />

            {/* service page */}
            <Route path={ROUTE_NAMES.DEVELOPMENTDESIGN} element={<DevelopmentDesignServices />} />
            {/* subservices */}
            {/* <Route path={ROUTE_NAMES.REALESTATEDEVELOPMENT} element={<RealEstateDevelopment />} />
            <Route path={ROUTE_NAMES.PREDEVELOPMENTPLANNING} element={<PreDevelopmentPlanningServices />} />
            <Route path={ROUTE_NAMES.DESIGNBUILD} element={<DesignBuildConstructionService />} />
            <Route path={ROUTE_NAMES.SMARTSUSTAINABLE} element={<SmartSustainableService />} /> */}

            {/* service page */}
            <Route path={ROUTE_NAMES.CAPITALINVESTMENT} element={<CapitalInvestmentServices />} />
            {/* subservices */}
            {/* <Route path={ROUTE_NAMES.CAPITALVENTURES} element={<CapitalVenturesServices />} />
            <Route path={ROUTE_NAMES.LENDINGSOLUTIONS} element={<LendingSolutionsServices />} /> */}
            <Route path={ROUTE_NAMES.EBSERVICE} element={<EBService />} />

            {/* service page */}
            <Route path={ROUTE_NAMES.CONSTRUCTIONSERVICE} element={<ConstructionServices />} />
            <Route path={ROUTE_NAMES.BROKERAGESERVICES} element={<BrokerageServices />} />
            <Route path={ROUTE_NAMES.MORTGAGESERVICES} element={<MortgageServices />} />
            <Route path={ROUTE_NAMES.LENDINGSERVICES} element={<LendingServices />} />
            {/* subservices */}
            {/* <Route path={ROUTE_NAMES.ELITEPROPERTYMANAGMENT} element={<ElitePropertyManagmentServices />} /> */}

            {/* project pages */}
            <Route path={ROUTE_NAMES.HOLLYWOOD} element={<HollywoodProject />} />
            <Route path={ROUTE_NAMES.STARLIFEPLAZA} element={<StarlifePlazaProject />} />
            <Route path={ROUTE_NAMES.RIVERLANDMANSION} element={<RiverlandMansionProject />} />
            <Route path={ROUTE_NAMES.RIVERLANDESTATES} element={<RiverlandEstatesProject />} />
            <Route path={ROUTE_NAMES.CORALRIDGEVILLAS} element={<CoralRidgeVillasProject />} />
            <Route path={ROUTE_NAMES.CORALRIDGERESIDENCES} element={<CoralRidgeResidencesProject />} />
            <Route path={ROUTE_NAMES.DANIABEACHVILLAS} element={<DaniaBeachVillasProject />} />

            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </>
    </BrowserRouter>
  );
}

export default App;
